import { render, staticRenderFns } from "./OnizleForm.vue?vue&type=template&id=a71a7c76&scoped=true"
import script from "./OnizleForm.vue?vue&type=script&lang=ts"
export * from "./OnizleForm.vue?vue&type=script&lang=ts"
import style0 from "./OnizleForm.vue?vue&type=style&index=0&id=a71a7c76&prod&scoped=true&lang=css"
import style1 from "./OnizleForm.vue?vue&type=style&index=1&id=a71a7c76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71a7c76",
  null
  
)

export default component.exports